import { gql } from 'graphql.macro';

export const addActionSetTemplate = gql`
    mutation addActionSet($title: String!, $currency: String!) {
        addActionSet(title: $title, currency: $currency) {
            _id
            title
            currency
        }
    }
`;

export const updateActionSetCurrencyTemplate = gql`
    mutation updateActionSetCurrency($actionSetId: MongoDbObjectId!, $currency: String!) {
        updateActionSetCurrency(actionSetId: $actionSetId, currency: $currency) {
            _id
            title
            currency
        }
    }
`;

export const setActionSetActiveTemplate = gql`
    mutation setActionSetActive($actionSetId: MongoDbObjectId!) {
        setActionSetActive(actionSetId: $actionSetId) {
            _id
            title
        }
    }
`;

export const saveMainCategoryTemplate = gql`
    mutation saveMainCategory(
        $_id: MongoDbObjectId
        $name: String!
        $instructions: String
        $actionSetId: MongoDbObjectId!
    ) {
        saveMainCategory(_id: $_id, name: $name, instructions: $instructions, actionSetId: $actionSetId)
    }
`;

export const deleteMainCategoryTemplate = gql`
    mutation deleteMainCategory($mainCategoryId: MongoDbObjectId!) {
        deleteMainCategory(mainCategoryId: $mainCategoryId)
    }
`;

export const saveSubCategoryTemplate = gql`
    mutation saveSubCategory(
        $_id: MongoDbObjectId
        $name: String!
        $parentCategoryId: MongoDbObjectId!
        $colorCode: String!
        $textColorCode: String!
    ) {
        saveSubCategory(
            _id: $_id
            name: $name
            parentCategoryId: $parentCategoryId
            colorCode: $colorCode
            textColorCode: $textColorCode
        )
    }
`;

export const deleteSubCategoryTemplate = gql`
    mutation deleteSubCategory($categoryId: MongoDbObjectId!, $subCategoryId: MongoDbObjectId!) {
        deleteSubCategory(categoryId: $categoryId, subCategoryId: $subCategoryId)
    }
`;

export const saveMaterialGroupTemplate = gql`
    mutation saveMaterialGroup(
        $_id: MongoDbObjectId
        $name: String!
        $materials: [GroupMaterialInput]
        $actionSetId: MongoDbObjectId!
    ) {
        saveMaterialGroup(_id: $_id, name: $name, materials: $materials, actionSetId: $actionSetId)
    }
`;

export const deleteMaterialGroupTemplate = gql`
    mutation deleteMaterialGroup($materialGroupId: MongoDbObjectId!) {
        deleteMaterialGroup(materialGroupId: $materialGroupId)
    }
`;

export const saveActionTemplate = gql`
    mutation saveAction(
        $actionSet: MongoDbObjectId!
        $_id: MongoDbObjectId
        $name: String!
        $number: String!
        $isNotesEnabled: Boolean
        $notes: String
        $mainCategory: MongoDbObjectId!
        $subCategory: [MongoDbObjectId!]!
        $materialGroup: MongoDbObjectId
        $costPerTooth: Boolean
        $teethOption: String
        $vat: Float
        $settings: ActionSettingsInput
        $denthubRestorationType: RestorationType!
        $quotable: Boolean
    ) {
        saveAction(
            actionSet: $actionSet
            _id: $_id
            name: $name
            number: $number
            isNotesEnabled: $isNotesEnabled
            notes: $notes
            mainCategory: $mainCategory
            subCategory: $subCategory
            materialGroup: $materialGroup
            costPerTooth: $costPerTooth
            teethOption: $teethOption
            vat: $vat
            settings: $settings
            denthubRestorationType: $denthubRestorationType
            quotable: $quotable
        )
    }
`;
export const deleteActionTemplate = gql`
    mutation deleteAction($actionId: MongoDbObjectId!) {
        deleteAction(actionId: $actionId)
    }
`;
